import { useMutation } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { IUpsertActivityRequest } from '../types/CrmActivityTypes';

export interface IUpdateActivityMutationParams {
  activityId: string;
  requestData: IUpsertActivityRequest;
}

export const useUpdateActivityMutation = () => {
  const crmApi = makeCRMApi();

  const updateActivityMutation = useMutation({
    mutationKey: ['crm-update-activity'],
    mutationFn: ({ activityId, requestData }: IUpdateActivityMutationParams) => crmApi.updateActivity(activityId, requestData),
  });

  return updateActivityMutation;
};
